module.exports = __webpack_public_path__ + "img/login-bg.70c34843.jpg";